import isEmpty from 'lodash/isEmpty'
import {useEffect, useState} from 'react'
import ModelExample from '../dataModels/ModelExample'
import ModelExampleCategory from '../dataModels/ModelExampleCategory'

export const useModelExampleCategories = (categoriesJSON: string) => {
  const [categories, setCategories] = useState<ModelExample[]>([])

  useEffect(() => {
    try {
      if (!isEmpty(categoriesJSON)) {
        let parsedCategories = JSON.parse(categoriesJSON)
        let finalCategories = parsedCategories.map((example: any) =>
          Object.assign(new ModelExampleCategory(), example)
        )
        setCategories(finalCategories)
      }
    } catch (e) {
      setCategories([])
    }
  }, [categoriesJSON])

  return categories
}
